import React from 'react'
import { useI18n } from '../../i18n'

type TimelineItem = {
  id: string
  at: string
  eventType: string
  severity: string
  summary: string
}

type Props = {
  items: TimelineItem[]
  compact?: boolean
}

function severityClass(severity: string) {
  if (severity === 'CRITICAL') return 'border-red-300 bg-red-50'
  if (severity === 'HIGH') return 'border-orange-300 bg-orange-50'
  if (severity === 'WARNING') return 'border-amber-300 bg-amber-50'
  return 'border-slate-200 bg-slate-50'
}

export default function OperationalEventTimeline({ items, compact }: Props) {
  const { t } = useI18n()
  if (!items.length) {
    return (
      <p className="text-xs text-slate-500 m-0">
        {t('complianceRuntime.noEvents', 'No operational events yet. Run recompute to reconcile telemetry.')}
      </p>
    )
  }

  return (
    <ul className={`m-0 p-0 list-none ${compact ? 'space-y-1' : 'space-y-2'}`}>
      {items.map((item) => (
        <li key={item.id} className={`text-xs rounded border px-2 py-1.5 ${severityClass(item.severity)}`}>
          <div className="flex justify-between gap-2">
            <span className="font-medium">{item.eventType}</span>
            <span className="text-slate-500 shrink-0">{new Date(item.at).toLocaleString()}</span>
          </div>
          <p className="m-0 mt-0.5 text-slate-700">{item.summary}</p>
        </li>
      ))}
    </ul>
  )
}
